<template>
  <div>
    <vxe-grid
      auto-resize
      ref="vxeGrid"
      highlight-hover-row
      :toolbar-config="tableToolbar"
      :data="tableData"
      :columns="tableColumns"
      :height="tableHeight"
      size="mini"
      :loading="loading"
      resizable
      border
      :expand-config="{ reserve: true }"
    >
      <template v-slot:toolbar_form>
        <slot name="header">
          <div>
            <span style="font-size: 14px; color: #0F0F0F;">{{
              $l('table_label_check_notPass') || '本次检出不良品记录'
            }}</span>
          </div>

          <!-- <b-button
              v-if="!disabled"
              class="mr-2"
              size="sm"
              :disabled="disabled"
              variant="outline-success"
              @click="openChooseGoods()"
              >{{ '添加报工人员' }}
            </b-button> -->

          <!-- <b-button
              class="mr-2"
              size="sm"
              variant="outline-danger"
              @click="batchDel()"
              :disabled="disabled"
            
              <i class="el-icon-delete" />
              {{ $l('INDEX.btn_delete') || '删除' }}
            </b-button> -->
        </slot>
      </template>
      <template v-slot:opt="{ row }">
        <div>
          <el-tooltip
            v-if="!disabled"
            class="item"
            effect="dark"
            :content="$l('INDEX.btn_tips_del') || '删除'"
            placement="top"
          >
            <i class="el-icon-delete tool-btn" @click="del(row)"></i>
          </el-tooltip>
        </div>
      </template>
      <template v-slot:spec="{ row }">
        <span>{{ row.spec || '' }}</span>
        <span>{{ row.specUnit || '' }}</span>
      </template>
    </vxe-grid>
    <ChooseUser
      :visible.sync="userDialogVisible"
      :title="'报工人员信息'"
      @confirm="userConfirm"
      type="checkbox"
    />
  </div>
</template>
<script>
import ChooseUser from './choose-user/dialog.vue'
import { cloneDeep } from 'lodash'
export default {
  mixins: [],
  components: { ChooseUser },
  props: {
    disabled: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    issuesList: { type: Array, default: () => [] },
    workLogTime: { type: String, default: '' },
  },
  watch: {
    issuesList: {
      handler() {
        this.tableData = cloneDeep(this.issuesList || [])
      },
      immediate: true,
    },
  },
  data() {
    return {
      tableHeight: 270,
      tableToolbar: {
        slots: {
          buttons: 'toolbar_form',
        },
      },
      tableColumns: [
        {
          field: 'seq',
          width: 50,
          align: 'center',
          type: 'seq',
        },
        // {
        //   field: 'checkbox',
        //   width: 40,
        //   align: 'center',
        //   type: 'checkbox',
        //   visible: !this.disabled,
        // },
        // {
        //   field: 'col-opt',
        //   title: this.$l('INDEX.table_label_operation') || '操作',
        //   align: 'center',
        //   width: 60,
        //   slots: {
        //     default: 'opt',
        //   },
        //   visible: !this.disabled,
        // },
        {
          title: this.$l('table_label_notPassQty') || '不良品数量',
          field: 'notPassQty',
          minWidth: 100,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
        {
          title: this.$l('table_label_qualityIssuesTitle') || '不良原因',
          field: 'qualityIssuesTitle',
          minWidth: 500,
          headerAlign: 'center',
          align: 'center',
          showHeaderOverflow: true,
          showOverflow: true,
        },
      ],
      tableData: [],
      userDialogVisible: false,
    }
  },
  methods: {
    getTableData() {
      return this.tableData
    },
    openChooseGoods() {
      this.userDialogVisible = true
    },
    userConfirm(data) {
      if (!data || !data.length) return
      const tableData = data.filter(
        (i) =>
          this.tableData.findIndex(
            (j) => j.noticeuserSpecCode === i.noticeuserSpecCode
          ) < 0
      )
      this.tableData.push(...tableData)
    },
    // 批量删除
    batchDel() {
      const data = this.getCheckboxRecords()
      if (!data || !data.length) return

      this.$confirm('您确定要删除所勾选数据吗?').then((type) => {
        if (type === 'confirm') {
          this.$refs.vxeGrid.removeCheckboxRow()
          data.forEach((item) => {
            this.tableData.forEach((row, index) => {
              if (row.userNo === item.userNo) {
                this.tableData.splice(index, 1)
              }
            })
          })
        }
      })
    },
    //单行删除
    del(row) {
      let index = this.$refs.vxeGrid.getRowIndex(row)
      this.tableData.splice(index, 1)
    },
    getCheckboxRecords() {
      const data = this.$refs.vxeGrid.getCheckboxRecords()
      if (!data || !data.length) {
        this.$message({
          message: this.$l('INDEX.tips_select_data') || '请选择需要操作的数据',
          type: 'warning',
        })
        return
      }
      return data
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .vxe-toolbar.size--mini {
  font-size: 12px;
  height: 25px;
}
</style>
